var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search__empty"},[_c('p',{staticClass:"txt"},[_c('span',{staticClass:"color"},[_vm._v("‘"+_vm._s(_vm.$route.query.keyword)+"’")]),_vm._v(" 에 대한 결과를 찾을수 없습니다."),_c('br'),_vm._v(" 이런 서비스는 어떠신가요? ")]),_c('RecoKeywords',{on:{"bind":_vm.bindWord,"check-apply":_vm.checkApply}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }